import { configureStore, isRejected, isRejectedWithValue } from '@reduxjs/toolkit';
import rootReducer from './reducers';
import { api } from './new_services/api';
import { showToast } from './new_services/toasts';
import { setStore } from './store-ref';

// Rejections that are *not* user-facing errors:
//   - `meta.condition === true` → RTK Query's hook skipped a refetch because
//     a `skip` flag or `condition` callback returned false. Happens every
//     time multiple components subscribe to the same query (e.g. the gallery
//     and the highlights panel both call useGetVariantGroupsQuery()), or
//     when a hook re-mounts.
//   - `meta.aborted === true` / `error.name === 'AbortError'` → an in-flight
//     fetch was cancelled because the args changed or the component
//     unmounted. Cosmetic only.
// We don't log or toast these — the console noise was hiding actual errors.
const isBenignRejection = (action) =>
  action?.meta?.condition === true ||
  action?.meta?.aborted === true ||
  action?.error?.name === 'ConditionError' ||
  action?.error?.name === 'AbortError';

const ErrorFallbackMiddleware = (api) => (next) => (action) => {

  if (isRejectedWithValue(action) && !isBenignRejection(action)) {
    console.error('isRejectedWithValue', action);

    let caption = action.payload?.data;
    if (action.payload?.data && action.payload.data.msg) {
      caption = action.payload.data.msg;
    }

    // Route the error notification through the same showToast action so
    // the toast call site is centralised in toasts.js. Avoids two parallel
    // toast helpers — and inherits the correct autoClose + close-button
    // behaviour automatically.
    api.dispatch(showToast({
      kind: 'error',
      title: 'Fehler bei der Verbindung zum Server',
      caption: caption || 'Bitte versuchen Sie es später erneut',
    }));
  } else if (isRejected(action) && !isBenignRejection(action)) {
    console.error('isRejected', action);
  }
  return next(action);
}

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      ignoredActionPaths: ['modal.modalProps.onSubmit']
    }
  }).concat(ErrorFallbackMiddleware).concat(api.middleware),
})

setStore(store);

export { store };
